module.exports = __webpack_public_path__ + "img/group_picture.be41837a.png";